export const blockIconsActionThumbUp = (
	<span className='material-symbols-outlined'>thumb_up</span>
);
